// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    max-width: 400px;
    margin: 50px auto;
    padding: 30px;
    background: #c8cff8;
    color: #ecf0f1;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    font-family: 'Roboto', sans-serif;
  }
  
  .login-container h2 {
    text-align: center;
    margin-bottom: 20px;
    color: #ecf0f1;
  }
  
  .login-container form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .login-container label {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .login-container input {
    padding: 12px;
    border: none;
    border-radius: 6px;
    font-size: 1rem;
  }
  
  .login-container input[type="text"],
  .login-container input[type="password"] {
    background-color: #f1f1f1;
    border: 1px solid #ccc;
    transition: border-color 0.3s ease;
  }
  
  .login-container input:focus {
    border-color: #00bcd4;
    outline: none;
  }
  
  .login-container button {
    padding: 12px;
    background: #00bcd4;
    border: none;
    color: #fff;
    cursor: pointer;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: bold;
    transition: background 0.3s ease;
  }
  
  .login-container button:hover {
    background: #008c9e;
  }
  
  .login-container button:active {
    background: #007284;
  }
  `, "",{"version":3,"sources":["webpack://./src/dashboard/styles/login.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,0CAA0C;IAC1C,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;IACzB,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".login-container {\n    max-width: 400px;\n    margin: 50px auto;\n    padding: 30px;\n    background: #c8cff8;\n    color: #ecf0f1;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n    font-family: 'Roboto', sans-serif;\n  }\n  \n  .login-container h2 {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #ecf0f1;\n  }\n  \n  .login-container form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .login-container label {\n    font-weight: bold;\n    margin-bottom: 5px;\n  }\n  \n  .login-container input {\n    padding: 12px;\n    border: none;\n    border-radius: 6px;\n    font-size: 1rem;\n  }\n  \n  .login-container input[type=\"text\"],\n  .login-container input[type=\"password\"] {\n    background-color: #f1f1f1;\n    border: 1px solid #ccc;\n    transition: border-color 0.3s ease;\n  }\n  \n  .login-container input:focus {\n    border-color: #00bcd4;\n    outline: none;\n  }\n  \n  .login-container button {\n    padding: 12px;\n    background: #00bcd4;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    border-radius: 6px;\n    font-size: 1rem;\n    font-weight: bold;\n    transition: background 0.3s ease;\n  }\n  \n  .login-container button:hover {\n    background: #008c9e;\n  }\n  \n  .login-container button:active {\n    background: #007284;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
